import React from 'react';
import appNavigationNames, { withActiveTab } from '../../utils/appNavigationNames';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { getIntl } from '../../utils/intl';
import { screens } from '../screens/Tabs/Resources';
import { MaybeDrawerLayout } from '../shared/MaybeSideNavLayout';
import { getHeader, mobileHeaderConfigs } from '../v2BaseComponents/Header';
import { colors } from '../../utils/theme';
import { useCapturedUrlUTMParameters } from '../../hooks/useUrlUTMParameters';

const intl = getIntl('resources-navigator', {
    root: 'Resources',
    addNote: 'Add Note',
    note: 'Note',
    editNote: 'Edit Note',
    addCareTeamMember: 'Add Care Team Member',
    editCareTeamMember: 'Edit Care Team Member',
    careTeamMember: 'Care Team Member',
});

const Stack = createNativeStackNavigator();

const ResourcesNavigatorNavigation = () => {
    const capturedUrlUTMParameters = useCapturedUrlUTMParameters();

    return (
        <MaybeDrawerLayout>
            <Stack.Navigator initialRouteName={appNavigationNames.resources.root}>
                <Stack.Screen
                    options={{
                        header: getHeader({ mobile: mobileHeaderConfigs.logo, breadCrumbs: [] }),
                        title: intl('root'),
                        contentStyle: {
                            backgroundColor: colors.Background,
                        },
                    }}
                    name={appNavigationNames.resources.root}
                    component={screens.ResourcesRootScreen}
                    initialParams={capturedUrlUTMParameters}
                />
                <Stack.Screen
                    options={{
                        header: getHeader({ mobile: mobileHeaderConfigs.logo, breadCrumbs: [] }),
                        title: intl('note'),
                        contentStyle: {
                            backgroundColor: colors.Background,
                        },
                    }}
                    name={appNavigationNames.resources.note}
                    component={screens.NoteDetailsScreen}
                    initialParams={capturedUrlUTMParameters}
                />
                <Stack.Screen
                    options={{
                        header: getHeader({ mobile: mobileHeaderConfigs.logo, breadCrumbs: [] }),
                        title: intl('addNote'),
                        contentStyle: {
                            backgroundColor: colors.Background,
                        },
                    }}
                    name={appNavigationNames.resources.addNote}
                    component={screens.AddNoteScreen}
                    initialParams={capturedUrlUTMParameters}
                />
                <Stack.Screen
                    options={{
                        header: getHeader({ mobile: mobileHeaderConfigs.logo, breadCrumbs: [] }),
                        title: intl('editNote'),
                        contentStyle: {
                            backgroundColor: colors.Background,
                        },
                    }}
                    name={appNavigationNames.resources.editNote}
                    component={screens.NoteEditScreen}
                    initialParams={capturedUrlUTMParameters}
                />
                <Stack.Screen
                    options={{
                        header: getHeader({ mobile: mobileHeaderConfigs.logo, breadCrumbs: [] }),
                        title: intl('addCareTeamMember'),
                        contentStyle: {
                            backgroundColor: colors.Background,
                        },
                    }}
                    name={appNavigationNames.resources.addCareTeamMember}
                    component={screens.AddCareTeamMemberScreen}
                    initialParams={capturedUrlUTMParameters}
                />
                <Stack.Screen
                    options={{
                        header: getHeader({ mobile: mobileHeaderConfigs.logo, breadCrumbs: [] }),
                        title: intl('editCareTeamMember'),
                        contentStyle: {
                            backgroundColor: colors.Background,
                        },
                    }}
                    name={appNavigationNames.resources.editCareTeamMember}
                    component={screens.EditCareTeamMemberScreen}
                    initialParams={capturedUrlUTMParameters}
                />
                <Stack.Screen
                    options={{
                        header: getHeader({ mobile: mobileHeaderConfigs.logo, breadCrumbs: [] }),
                        title: intl('careTeamMember'),
                        contentStyle: {
                            backgroundColor: colors.Background,
                        },
                    }}
                    name={appNavigationNames.resources.careTeamMember}
                    component={screens.CareTeamMemberScreen}
                    initialParams={capturedUrlUTMParameters}
                />
            </Stack.Navigator>
        </MaybeDrawerLayout>
    );
};

export default withActiveTab(ResourcesNavigatorNavigation, 'resources');
